"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
  This wraps react-final-form's <Field/> component.
  The identity function ensures form values never get set to null, but rather, empty strings.

  See https://github.com/final-form/react-final-form/issues/130
*/
var _default = exports["default"] = function _default(value) {
  return value;
};